module.exports = __webpack_public_path__ + "static/media/green_circle.653af2c0.svg";